import React from "react";
import { useNavigate } from "react-router-dom";

function Login() {
  const logoSrc = "/buildcarboniq-logo.png";

  const features = [
    {
      title: "Upload & Analyze",
      text: "Import BOQs or Excel material lists in seconds.",
      type: "upload",
    },
    {
      title: "AI-Powered LCA",
      text: "Calculate embodied carbon with industry-leading models.",
      type: "search",
    },
    {
      title: "Pinpoint Hotspots",
      text: "Identify the biggest CO₂ contributors with forensic precision.",
      type: "chart",
    },
    {
      title: "Auditable & Trustworthy",
      text: "Get transparent, verifiable results you can rely on.",
      type: "shield",
    },
  ];

  const renderFeatureIcon = (type) => {
    const wrapStyle = {
      width: 78,
      height: 78,
      margin: "0 auto 18px auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 22,
      background: "radial-gradient(circle at 30% 30%, rgba(59,130,246,0.30), rgba(15,23,42,0.02))",
      boxShadow: "0 10px 24px rgba(0,0,0,0.18)",
    };

    const svgCommon = {
      width: 54,
      height: 54,
      viewBox: "0 0 64 64",
      fill: "none",
    };

    if (type === "upload") {
      return (
        <div style={wrapStyle}>
          <svg {...svgCommon}>
            <defs>
              <linearGradient id="gUpload" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#7dd3fc" />
                <stop offset="100%" stopColor="#2563eb" />
              </linearGradient>
            </defs>
            <path d="M18 10h18l10 10v30a4 4 0 0 1-4 4H18a4 4 0 0 1-4-4V14a4 4 0 0 1 4-4Z" fill="url(#gUpload)" opacity="0.95" />
            <path d="M36 10v10h10" fill="#bfdbfe" opacity="0.9" />
            <path d="M32 44V26" stroke="#e0f2fe" strokeWidth="4" strokeLinecap="round" />
            <path d="m24 33 8-8 8 8" stroke="#e0f2fe" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M22 50h20" stroke="#dbeafe" strokeWidth="4" strokeLinecap="round" />
          </svg>
        </div>
      );
    }

    if (type === "search") {
      return (
        <div style={wrapStyle}>
          <svg {...svgCommon}>
            <defs>
              <linearGradient id="gSearch" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#60a5fa" />
                <stop offset="100%" stopColor="#1d4ed8" />
              </linearGradient>
              <linearGradient id="gLeaf" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#a3e635" />
                <stop offset="100%" stopColor="#22c55e" />
              </linearGradient>
            </defs>
            <circle cx="28" cy="28" r="16" stroke="url(#gSearch)" strokeWidth="6" />
            <path d="M40 40l10 10" stroke="url(#gSearch)" strokeWidth="6" strokeLinecap="round" />
            <path d="M24 31c8-13 19-11 19-11-1 9-6 15-16 16-3 0-5-2-5-5Z" fill="url(#gLeaf)" opacity="0.95" />
            <path d="M23 35c4-6 8-10 15-14" stroke="#14532d" strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        </div>
      );
    }

    if (type === "chart") {
      return (
        <div style={wrapStyle}>
          <svg {...svgCommon}>
            <defs>
              <linearGradient id="gBar1" x1="0" y1="1" x2="0" y2="0">
                <stop offset="0%" stopColor="#2563eb" />
                <stop offset="100%" stopColor="#60a5fa" />
              </linearGradient>
              <linearGradient id="gBar2" x1="0" y1="1" x2="0" y2="0">
                <stop offset="0%" stopColor="#22c55e" />
                <stop offset="100%" stopColor="#bef264" />
              </linearGradient>
            </defs>
            <rect x="10" y="32" width="10" height="20" rx="3" fill="url(#gBar1)" />
            <rect x="26" y="22" width="10" height="30" rx="3" fill="url(#gBar1)" />
            <rect x="42" y="12" width="10" height="40" rx="3" fill="url(#gBar2)" />
            <path d="M10 54h44" stroke="#bfdbfe" strokeWidth="3" strokeLinecap="round" />
          </svg>
        </div>
      );
    }

    return (
      <div style={wrapStyle}>
        <svg {...svgCommon}>
          <defs>
            <linearGradient id="gShield" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#60a5fa" />
              <stop offset="100%" stopColor="#1d4ed8" />
            </linearGradient>
          </defs>
          <path d="M32 8 50 14v14c0 13-7 21-18 28C21 49 14 41 14 28V14L32 8Z" fill="url(#gShield)" opacity="0.95" />
          <path d="m23 31 6 6 12-14" stroke="#bbf7d0" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    );
  };
  const navigate = useNavigate();

return (
  <div
    style={{
      minHeight: "100vh",
      background:
        "radial-gradient(circle at 20% 18%, rgba(59,130,246,0.22), transparent 22%), radial-gradient(circle at 82% 68%, rgba(125,211,252,0.18), transparent 24%), linear-gradient(180deg, #0d2f78 0%, #0a2563 32%, #071a4c 62%, #041235 100%)",
      padding: "34px 24px 60px 24px",
      color: "#ffffff",
      position: "relative",
      overflow: "hidden",
    }}
  >

    {/* STEP 2 — ATMOSPHERIC OVERLAY */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        background:
          "radial-gradient(circle at 50% 12%, rgba(255,255,255,0.10), transparent 18%), radial-gradient(circle at 78% 76%, rgba(186,230,253,0.16), transparent 22%), radial-gradient(circle at 14% 82%, rgba(59,130,246,0.12), transparent 26%)",
        mixBlendMode: "screen",
        zIndex: 0,
      }}
    />

        <div
          style={{
            maxWidth: 1120,
            margin: "0 auto",
            position: "relative",
            zIndex: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              marginBottom: 34,
            }}
          >
            <div
              style={{
                position: "relative",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  inset: "-18px -24px",
                  background:
                    "radial-gradient(circle, rgba(56,189,248,0.18) 0%, rgba(59,130,246,0.10) 38%, rgba(15,23,42,0) 72%)",
                  filter: "blur(10px)",
                  pointerEvents: "none",
                }}
              />
              <img
                src={logoSrc}
                alt="BuildCarbonIQ"
                style={{
                  width: 380,
                  height: "auto",
                  display: "block",
                  position: "relative",
                  zIndex: 1,
                  filter: "drop-shadow(0 10px 24px rgba(0,0,0,0.18))",
                }}
              />
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              maxWidth: 920,
              margin: "0 auto 30px auto",
              position: "relative",
              zIndex: 1,
            }}
          >
          <div
            style={{
              fontSize: window.innerWidth < 900 ? 40 : 56,
              lineHeight: window.innerWidth < 900 ? 1.14 : 1.1,
              fontWeight: 800,
              marginBottom: 18,
              textShadow: "0 12px 28px rgba(0,0,0,0.22)",
              letterSpacing: "-0.6px",
            }}
          >
            The truth-dependable,
            <br />
            AI-powered LCA tool.
          </div>

          <div
            style={{
              width: 220,
              height: 2,
              background: "rgba(255,255,255,0.28)",
              margin: "0 auto 22px auto",
            }}
          />

          <p
            style={{
              fontSize: window.innerWidth < 900 ? 17 : 19,
              lineHeight: window.innerWidth < 900 ? "30px" : "34px",
              color: "#e0ecff",
              maxWidth: 860,
              margin: "0 auto",
              textShadow: "0 8px 20px rgba(0,0,0,0.16)",
            }}
          >
            Transform your Bills of Quantities and Excel material lists into
            auditable insights to pinpoint CO<sub>2</sub> emission hotspots with
            forensic precision.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              window.innerWidth < 900
                ? "repeat(1, minmax(0, 1fr))"
                : "repeat(4, minmax(0, 1fr))",
            gap: 0,
            background: "linear-gradient(180deg, rgba(10,33,86,0.82), rgba(8,27,74,0.74))",
            border: "1px solid rgba(147,197,253,0.16)",
            borderRadius: 34,
            boxShadow: "0 28px 70px rgba(0,0,0,0.34), inset 0 1px 0 rgba(255,255,255,0.05)",
            overflow: "hidden",
            backdropFilter: "blur(14px)",
            maxWidth: 1040,
            margin: "0 auto 48px auto",
            position: "relative",
            zIndex: 1,
          }}
        >
          {features.map((feature, index) => (
            <div
              key={feature.title}
              style={{
                padding: "30px 22px 26px 22px",
                borderRight:
                  window.innerWidth >= 900 && index < features.length - 1
                    ? "1px solid rgba(255,255,255,0.10)"
                    : "none",
                borderBottom:
                  window.innerWidth < 900 && index < features.length - 1
                    ? "1px solid rgba(255,255,255,0.10)"
                    : "none",
                textAlign: "center",
                minHeight: window.innerWidth < 900 ? "auto" : 210,
              }}
            >
              {renderFeatureIcon(feature.type)}
              <div
                style={{
                  fontSize: 18,
                  fontWeight: 800,
                  marginBottom: 10,
                  color: "#ffffff",
                }}
              >
                {feature.title}
              </div>
              <div
                style={{
                  fontSize: 15,
                  lineHeight: "28px",
                  color: "#d7e7ff",
                }}
              >
                {feature.text}
              </div>
            </div>
          ))}
        </div>

        <div
          style={{
            width: "100%",
            maxWidth: 520,
            margin: "0 auto",
            background: "linear-gradient(180deg, rgba(255,255,255,0.96), rgba(244,247,255,0.94))",
            color: "#0f172a",
            border: "1px solid rgba(191,219,254,0.45)",
            borderRadius: 24,
            padding: "34px 34px 28px 34px",
            boxShadow: "0 28px 70px rgba(0,0,0,0.30)",
            backdropFilter: "blur(14px)",
            position: "relative",
            zIndex: 1,
          }}
        >
        <h1
          style={{
            marginTop: 0,
            marginBottom: 10,
            fontSize: "22px",
            fontWeight: 800,
            color: "#16326b",
          }}
        >
          Email
        </h1>

        <p
          style={{
            marginTop: 0,
            marginBottom: 22,
            color: "#64748b",
            fontSize: 14,
            lineHeight: "22px",
          }}
        >
          Access your BuildCarbonIQ workspace and continue your carbon
          assessment workflow.
        </p>

        <div
          style={{
            marginTop: "12px",
            padding: "12px 14px",
            borderRadius: "10px",
            background: "#eef6ff",
            border: "1px solid #cfe3ff",
            color: "#1e40af",
            fontSize: "14px",
            lineHeight: "22px",
            fontWeight: "500",
          }}
        >
          Pilot testing mode is currently enabled. Simply click Log In to access the platform.
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 13, color: "#475569" }}>Email</label>
          <input
            type="email"
            placeholder="Email"
            style={{
              width: "100%",
              marginTop: 6,
              padding: "14px 16px",
              borderRadius: 12,
              border: "1px solid #cbd5e1",
              background: "#ffffff",
              color: "#0f172a",
              outline: "none",
              fontSize: 16,
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ marginBottom: 18 }}>
          <label style={{ fontSize: 13, color: "#475569" }}>Password</label>
          <input
            type="password"
            placeholder="Password"
            style={{
              width: "100%",
              marginTop: 6,
              padding: "14px 16px",
              borderRadius: 12,
              border: "1px solid #cbd5e1",
              background: "#ffffff",
              color: "#0f172a",
              outline: "none",
              fontSize: 16,
              boxSizing: "border-box",
            }}
          />
        </div>

        <button
          onClick={() => navigate("/how-it-works")}
          style={{
            width: "100%",
            background: "linear-gradient(135deg, #0f5eea, #39bdf8)",
            color: "#ffffff",
            border: "none",
            boxShadow: "0 14px 32px rgba(37, 99, 235, 0.38), inset 0 1px 0 rgba(255,255,255,0.22)",
            padding: "16px",
            borderRadius: 12,
            cursor: "pointer",
            fontWeight: 800,
            fontSize: "18px",
          }}
        >
          Log In
        </button>

        <p
          style={{
            marginTop: 18,
            marginBottom: 0,
            fontSize: 15,
            color: "#475569",
            textAlign: "center",
          }}
        >
          Don't have an account?{" "}
          <span style={{ color: "#2563eb", fontWeight: 700 }}>Sign up</span>
        </p>

        <p
          style={{
            marginTop: 18,
            fontSize: 12,
            color: "#94a3b8",
            textAlign: "center",
          }}
        >
          © 2024 BuildCarbonIQ | All rights reserved.
        </p>
      </div>
    </div>
  </div>
  );
}

export default Login;